import { observer, Observer } from 'mobx-react-lite'
import { NavLink } from 'react-router-dom'

import menuItems, { MenuItem } from 'components/Dashboard/menuConfig'
import NotificationBubble from 'components/Dashboard/common/NotificationBubble'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

type IconWithBubbleProps = Pick<MenuItem, 'IconComponent' | 'getNotificationsAmount'>

const IconWithBubble = ({ getNotificationsAmount, IconComponent }: IconWithBubbleProps) => {
  return (
    <div className="relative text-center">
      <IconComponent className="w-5 sm:w-6 h-5 sm:h-6 inline-block" />
      <Observer>
        {() => {
          const amount = getNotificationsAmount ? getNotificationsAmount() : 0

          return amount ? <NotificationBubble amount={amount} isMobile /> : null
        }}
      </Observer>
    </div>
  )
}

const MobileMenuContent = () => {
  const items = menuItems()

  return items.map(({ title, route, exact, IconComponent, getNotificationsAmount }) => (
    <NavLink
      to={route}
      end={exact}
      className={({ isActive }) =>
        classNames(
          'flex flex-col item-center justify-start typography-small sm:typography-body',
          isActive ? 'text-primary-800' : 'text-neutral-400/75',
        )
      }
      style={{ width: `${100 / items.length}%` }}
    >
      <IconWithBubble getNotificationsAmount={getNotificationsAmount} IconComponent={IconComponent} />
      <p className="max-w-full whitespace-nowrap overflow-hidden text-ellipsis">{title}</p>
    </NavLink>
  ))
}

export default observer(MobileMenuContent)
